export default __webpack_public_path__ + "static/media/p12.601a51a5.jpg";